const state = {
    passSanitairedata: localStorage.getItem('passSanitaire-09092021b-data') || null
};

const mutations = {
    setData(state) {
        let data = { already_displayed: true };
        localStorage.setItem('passSanitaire-09092021b-data', JSON.stringify(data));
        state.passSanitairedata = data;
    }
};

const actions = {
    setData(context) {
        return new Promise((resolve) => {
            context.commit('setData');
            resolve();
        });
    },
    getData(context) {
        return new Promise((resolve) => {
            let data = JSON.parse(context.state.passSanitairedata);
            resolve(data);
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};